import { render, staticRenderFns } from "./PatientVnrecordList.vue?vue&type=template&id=d9142838&"
import script from "./PatientVnrecordList.vue?vue&type=script&lang=ts&"
export * from "./PatientVnrecordList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports